import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleTagWithNewsCount extends BaseModel {
  static override constructorName = 'ArticleTagWithNewsCount'

  id: number = 0
  name: string = ''
  'news_count': number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ArticleTagWithNewsCount)
